module.exports = __webpack_public_path__ + "assets/perfex-crm.ce639008.svg";